import React from "react";
import { UserAuthProvider } from "../user_management/UserAuthContext";
import ShippingDashboard from "./ShippingDashboard";

export default function ShippingModule({ initialView = "queue" }) {
  return <UserAuthProvider><ShippingDashboard key={initialView} initialView={initialView} /></UserAuthProvider>;
}
